/* =====================================================================
   LUMIQO — lq-ugc-videos.js (sections/lq-ugc-videos.liquid)
   [data-lq-ugc-play] on a card with video.lq-ugc__video → plays it with controls (pauses others);
   [data-lq-ugc-soon] (no video yet) → shows the card's [data-lq-ugc-soon-msg] note.
   Delegated listener, so it survives section re-renders in the theme editor.
   ===================================================================== */
if (!window.__lqUgcVideos) {
  window.__lqUgcVideos = true;

  /** @param {HTMLVideoElement} video */
  const stop = (video) => {
    video.pause();
    video.controls = false;
    video.closest('[data-lq-ugc-card]')?.classList.remove('is-playing');
  };

  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    const soon = target.closest('[data-lq-ugc-soon]');
    if (soon) {
      const note = soon.closest('[data-lq-ugc-card]')?.querySelector('[data-lq-ugc-soon-msg]');
      if (note instanceof HTMLElement) {
        note.textContent = note.dataset.text || '';
        note.hidden = false;
      }
      return;
    }

    const play = target.closest('[data-lq-ugc-play]');
    if (!play) return;
    const card = play.closest('[data-lq-ugc-card]');
    const video = card?.querySelector('video.lq-ugc__video');
    if (!(video instanceof HTMLVideoElement) || !card) return;
    for (const other of document.querySelectorAll('video.lq-ugc__video')) {
      if (other !== video && other instanceof HTMLVideoElement && !other.paused) stop(other);
    }
    video.muted = false;
    video.controls = true;
    card.classList.add('is-playing');
    video.play().catch(() => {
      // autoplay with sound blocked: fall back to muted playback with controls
      video.muted = true;
      video.play().catch(() => {});
    });
    // native controls take over from here (pause / resume / fullscreen)
    video.focus({ preventScroll: true });
  });

  // stop playback when a section is reloaded in the editor or the tab is hidden
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    for (const v of document.querySelectorAll('video.lq-ugc__video')) if (v instanceof HTMLVideoElement && !v.paused) v.pause();
  });
}
